<template>
  <router-view />
</template>

<script>
// support new UI in legacy code
import { initParentConnection } from '@/lib/parentConnection';

// update vuetify theme globally
import theme from '@/factories/theme';

import initTrackJs from '@/lib/trackjs';
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations(['setInstallAppPrompt']),
    applyTheme(config) {
      if (!config?.colors) return;
      // URL `?theme=` is the in-app brand preview. Host setTheme on an
      // embed must still win, even if the query string happens to
      // mention "theme".
      const preview =
        window.location.search.indexOf('theme') !== -1 &&
        !window.location.pathname.includes('/embed/');
      if (preview) return;
      this.$vuetify.theme.dark = !!config.isDark;
      this.$vuetify.theme.themes[config.isDark ? 'dark' : 'light'] =
        config.colors;
      document.documentElement.style.colorScheme = config.isDark
        ? 'dark'
        : 'normal';
      document.documentElement.classList.toggle('theme--dark', !!config.isDark);
    },

    addThemeListener() {
      theme.on('customThemeSet', (config) => this.applyTheme(config));
      this.applyTheme({
        isDark: theme.isDark,
        colors: theme.colors,
      });
    },

    addInstallPromptListener() {
      window.addEventListener('beforeinstallprompt', (event) => {
        this.setInstallAppPrompt(event);
      });
    },
  },

  created() {
    this.addInstallPromptListener();
    initParentConnection();
    this.addThemeListener();
    initTrackJs();
  },
};
</script>

<style lang="less" src="@/assets/styles/app/app-main.less"></style>
<style lang="less" src="@/assets/styles/app/page-markdown.less"></style>
<style lang="less" src="@/assets/styles/app/page-node.less"></style>
<style lang="less" src="@/assets/styles/basic/animations.less"></style>
<style lang="less" src="@/assets/styles/basic/vuetify/index.less"></style>
<style lang="less" src="@/assets/styles/basic/item-card.less"></style>
